module.exports = __webpack_public_path__ + "../resources/img/ic_re_play_light.3d4fceba.svg";